export default __webpack_public_path__ + "static/media/Imagem5.291d0041.png";